/**
 * Editorial header: scroll solid state + mobile drawer a11y.
 * Used when Header section layout is Editorial (`snippets/header-editorial.liquid`).
 * Targets `#header-component.header-custom-editorial`.
 */
(function () {
  const root = document.querySelector('#header-component.header-custom-editorial');
  if (!root) return;

  const scrollThreshold = parseInt(root.dataset.scrollThreshold || '8', 10);
  const forceSolid = root.dataset.forceSolid === 'true';

  let raf = null;

  function applyScrollState() {
    raf = null;
    const y = window.scrollY || document.documentElement.scrollTop || 0;
    const scrolled = forceSolid || y > scrollThreshold;
    root.classList.toggle('header-custom--scrolled', scrolled);
    root.dataset.headerSolid = scrolled ? 'true' : 'false';
  }

  function onScroll() {
    if (raf != null) return;
    raf = requestAnimationFrame(applyScrollState);
  }

  applyScrollState();
  window.addEventListener('scroll', onScroll, { passive: true });

  /** ---- Mobile drawer (dialog) ---- */
  const drawerId = root.dataset.drawerId;
  const dialog = drawerId ? document.getElementById(drawerId) : null;
  const openBtn = root.querySelector('[data-header-custom-open]');
  const closeBtn = dialog?.querySelector('[data-header-custom-close]');

  if (!dialog || !openBtn || !(dialog instanceof HTMLDialogElement)) return;

  const focusableSelector =
    'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

  let lastFocus = null;

  function getFocusable() {
    return Array.from(dialog.querySelectorAll(focusableSelector)).filter(
      (el) => el.offsetParent !== null || el === closeBtn
    );
  }

  function trapFocus(e) {
    if (e.key !== 'Tab') return;
    const list = getFocusable();
    if (!list.length) return;
    const first = list[0];
    const last = list[list.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  }

  function openDrawer() {
    lastFocus = document.activeElement;
    dialog.showModal();
    openBtn.setAttribute('aria-expanded', 'true');
    const list = getFocusable();
    (list[0] || closeBtn)?.focus();
    dialog.classList.add('header-custom-drawer--open');
  }

  function closeDrawer() {
    dialog.close();
    openBtn.setAttribute('aria-expanded', 'false');
    dialog.classList.remove('header-custom-drawer--open');
    if (lastFocus instanceof HTMLElement) lastFocus.focus();
    lastFocus = null;
  }

  openBtn.addEventListener('click', () => {
    if (dialog.open) closeDrawer();
    else openDrawer();
  });

  closeBtn?.addEventListener('click', closeDrawer);

  dialog.addEventListener('cancel', (e) => {
    e.preventDefault();
    closeDrawer();
  });

  dialog.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      e.preventDefault();
      closeDrawer();
    } else {
      trapFocus(e);
    }
  });
})();
